// src/components/shared/CardContainer.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardHeader,
  CardContent,
  Box
} from '@mui/material';

/**
 * Componente contenedor para tarjetas con encabezado consistente
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.title - Título principal de la tarjeta
 * @param {string} props.subheader - Subtítulo opcional para la tarjeta
 * @param {React.ReactNode} props.actionComponent - Componente para mostrar en la sección de acciones del encabezado
 * @param {React.ReactNode} props.children - Contenido de la tarjeta
 * @param {Object} props.headerProps - Props adicionales para el CardHeader
 * @param {Object} props.contentProps - Props adicionales para el CardContent
 * @param {Object} props.cardProps - Props adicionales para el componente Card
 */
const CardContainer = ({
  title,
  subheader,
  actionComponent,
  children,
  headerProps = {},
  contentProps = {},
  cardProps = {},
}) => {
  return (
    <Card {...cardProps}>
      {(title || subheader || actionComponent) && (
        <CardHeader
          title={title}
          subheader={subheader}
          action={actionComponent}
          {...headerProps}
        />
      )}
      <CardContent {...contentProps}>
        {children}
      </CardContent>
    </Card>
  );
};

CardContainer.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  actionComponent: PropTypes.node,
  children: PropTypes.node,
  headerProps: PropTypes.object,
  contentProps: PropTypes.object,
  cardProps: PropTypes.object,
};

export default CardContainer;